import UnitModel from '@/_models/UnitModel'
import { commonService } from '../../_services'
const service = commonService('api/v1/admin/unit')

export const units = {
  namespaced: true,
  state: {
    all: { items: [], beacons: [], floors: [], cards: [], users: [] },
    item: {},
    loading: false,
  },
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')
      return service.getAll().then((resp) => {
        context.commit('GET_ALL_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async getOne(context: any, id): Promise<void> {
      context.commit('GET_REQUEST')
      return service.getOne(id).then((resp) => {
        context.commit('GET_ONE_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return service.addOne(data).then((resp) => {
        // Fetch just added data
        service.getOne(resp.data._id).then(singleData => {
          context.commit('ADD_ITEM_SUCCESS', singleData.data)
        })
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('UPDATE_REQUEST')

      return service.updateOne(data).then((resp) => {
        return service.getOne(resp.data._id).then(singleData => {
          context.commit('UPDATE_ITEM_SUCCESS', singleData.data)
          return Promise.resolve(singleData.data)
        })
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async deleteOne(context: any, data: any): Promise<void> {
      context.commit('DELETE_REQUEST')

      return service.deleteOne(data._id).then((resp) => {
        context.commit('DELETE_ITEM_SUCCESS', data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async uploadFile(context: any, file: File): Promise<void> {
      context.commit('FILE_UPLOADING')
      return service.uploadFile(file).then((resp) => {
        context.commit('UPLOAD_FINISHED')
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async hasRefs(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')
      return service.hasRefs(data._id).then((resp) => {
        context.commit('GET_REQUEST_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async getAllBeacons(context: any, unit: UnitModel): Promise<void> {
      context.commit('GET_REQUEST')
      return commonService(`api/v1/admin/unit/beacon`).addOne({ db_name: unit.db_name }).then((resp) => {
        context.commit('GET_ALL_BEACONS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async getAllFloors(context: any, unit: UnitModel): Promise<void> {
      context.commit('GET_REQUEST')
      return commonService(`api/v1/admin/unit/floor`).addOne({ db_name: unit.db_name }).then((resp) => {
        context.commit('GET_ALL_FLOORS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async getAllCards(context: any, unit: UnitModel): Promise<void> {
      context.commit('GET_REQUEST')
      return commonService(`api/v1/admin/unit/card`).addOne({ db_name: unit.db_name }).then((resp) => {
        context.commit('GET_ALL_CARDS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async getAllUsers(context: any, unit: UnitModel): Promise<void> {
      context.commit('GET_REQUEST')
      return commonService(`api/v1/admin/unit/user`).addOne({ db_name: unit.db_name }).then((resp) => {
        context.commit('GET_ALL_USERS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async deleteAllData(context: any, payload: any): Promise<void> {
      context.commit('DELETE_REQUEST')
      return commonService(`api/v1/admin/unit/tracking-data`).postData(payload).then((resp) => {
        context.commit('GET_REQUEST_SUCCESS')
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async deleteMany(context: any, payload: any): Promise<void> {
      context.commit('DELETE_REQUEST')
      const { collection, ids } = payload

      return commonService(`api/v1/admin/unit/delete`).postData(payload).then((resp) => {
        context.commit('DELETE_ITEMS_SUCCESS', {ids, collection})
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async hasRefsCollection(context: any, payload: any): Promise<void> {
      context.commit('GET_REQUEST')
      return commonService(`api/v1/admin/unit/has-refs`).postData(payload).then((resp) => {
        context.commit('GET_REQUEST_SUCCESS')
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      allItems.map(item => {
        return item
      })

      state.all = { ...state.all, items: allItems }
      state.loading = false
    },
    GET_ALL_BEACONS(state: any, allItems: any[]) {
      state.all = { ...state.all, beacons: allItems }
      state.loading = false
    },
    GET_ALL_FLOORS(state: any, allItems: any[]) {
      state.all = { ...state.all, floors: allItems }
      state.loading = false
    },
    GET_ALL_CARDS(state: any, allItems: any[]) {
      state.all = { ...state.all, cards: allItems }
      state.loading = false
    },
    GET_ALL_USERS(state: any, allItems: any[]) {
      state.all = { ...state.all, users: allItems }
      state.loading = false
    },
    GET_ONE_SUCCESS(state: any, item: any) {
      state.item = item
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [], floors: [], beacons: [], cards: [], users: [] }
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_REQUEST_SUCCESS(state: any) {
      state.loading = false
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.item = item

      state.loading = false
    },
    FILE_UPLOADING(state: any) {
      state.loading = true
    },
    UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items.indexOf(item)
      state.all.items.splice(index, 1)
      state.loading = false
    },
    DELETE_ITEMS_SUCCESS(state: any, payload: any) {
      const { ids, collection } = payload
      
      state.all[`${collection}s`] = state.all[`${collection}s`]?.filter(item => !ids.includes(item._id))
      state.loading = false
    },
    REQUEST_ERROR(state: any, error: any) {
      state.loading = false
    }
  },
  getters: {
    canEdit: state => () => {
      return service.canEdit()
    },
    canDelete: state => () => {
      return service.canDelete()
    },
  },
}
